<template>
    <v-data-table
      :headers="tableHeaders"
      :items="items"
      item-key="id"
      :search="search"
      :custom-filter="filterFunction"
      class="mt-4"
    >
      <template v-slot:top="{}">
        <v-row justify="end" align="baseline" align-content="center">
          <v-col sm="8" md="9">
            <v-text-field
              v-model="search"
              label="Search"
              dense
              clearable
            />
          </v-col>
          <v-spacer />
          <v-col>
            <v-btn
              rounded
              color="primary"
              @click="$emit('ADD')"
            >
              <v-icon>mdi-plus</v-icon>
              {{ $t('dictionaries.newItem') }}
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.area="{ item }">
        {{item.area.name}}
      </template>
      <template v-slot:item.users="{ item }">
        <v-chip
          v-for="user in item.users"
          :key="user.mailNickname"
          small
          class="ma-1"
        >
          {{user.displayName}}
        </v-chip>
      </template>
      <template v-slot:item.user="{ item }">
        <v-chip
          small
          class="ma-1"
        >
          {{item.user.displayName}}
        </v-chip>
      </template>
      <template v-slot:item.project="{ item }">
        {{item.project.name}}
      </template>
      <template v-slot:item.areas="{ item }">
        <v-chip
          v-for="area in item.areas"
          :key="area.code"
          small
          class="mx-1"
        >
          {{area.name}}
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          small
          @click="$emit('EDIT', item)"
        >
          <v-icon>mdi-pencil </v-icon>
        </v-btn>
        <SubmitButton
          icon="mdi-delete"
          small
          @click="$emit('DELETE', item.id)"
        />
      </template>
    </v-data-table>
</template>

<script>
export default {
  name: 'DictionaryTable',
  props: {
    headers: Array,
    items: Array,
    title: String
  },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    tableHeaders () {
      return [
        ...this.headers,
        { text: '', value: 'actions', sortable: false }
      ]
    }
  },
  methods: {
    filterFunction (value, search) {
      switch (typeof value) {
        case 'string':
          return value.toUpperCase().includes(search.toUpperCase())
        case 'object':
          if (Array.isArray(value)) {
            return value.some(v => (v.name || v.displayName).toUpperCase().includes(search.toUpperCase()))
          } else {
            return value.name.toUpperCase().includes(search.toUpperCase())
          }
        case 'array':
        default:
          return false
      }
    }
  }
}
</script>
